import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Label } from '../ui/label';
import { ChefHat, AlertCircle, Loader2 } from 'lucide-react';

const RecipeIntegration = ({
 checkingAccess,
 hasRecipeAccess,
 selectedRecipeId,
 handleRecipeSelect,
 recipes
}) => {
 const navigate = useNavigate();

 return (
 <Card className="border-2 border-primary/30 dark:border-primary/30">
 <CardHeader>
 <div className="flex items-center justify-between">
 <div>
 <CardTitle className="flex items-center gap-2">
 <ChefHat className="w-5 h-5 text-primary" />
 Use Existing Recipe
 <Badge variant="secondary" className="ml-2 bg-primary/5 text-primary dark:bg-primary/20 dark:text-primary">
 Pro
 </Badge>
 </CardTitle>
 <CardDescription>Auto-populate ingredient costs from your saved recipes</CardDescription>
 </div>
 </div>
 </CardHeader>
 <CardContent>
 {checkingAccess ? (
 <div className="flex items-center justify-center py-4">
 <Loader2 className="w-5 h-5 animate-spin" />
 </div>
 ) : !hasRecipeAccess ? (
 <div className="bg-primary/5 dark:bg-primary/20/20 p-4 rounded-lg border border-primary/30 dark:border-primary/30">
 <div className="flex items-start gap-3">
 <AlertCircle className="w-5 h-5 text-primary mt-0.5" />
 <div className="flex-1">
 <p className="text-sm font-semibold text-primary dark:text-primary">Tier 1 Pro Feature</p>
 <p className="text-xs text-primary dark:text-primary mt-1">
 Upgrade to Pro to integrate your recipes and auto-populate ingredient costs.
 </p>
 <Button
 variant="default"
 size="sm"
 className="mt-3 bg-primary hover:bg-primary/90"
 onClick={() => navigate('/pricing')}
 >
 Upgrade to Pro
 </Button>
 </div>
 </div>
 </div>
 ) : (
 <div className="space-y-4">
 <div className="space-y-2">
 <Label>Select Recipe</Label>
 <Select value={selectedRecipeId} onValueChange={handleRecipeSelect}>
 <SelectTrigger>
 <SelectValue placeholder="Choose a recipe..." />
 </SelectTrigger>
 <SelectContent>
 {recipes.length === 0 ? (
 <SelectItem value="none" disabled>No recipes found</SelectItem>
 ) : (
 recipes.map(recipe => (
 <SelectItem key={recipe.id} value={recipe.id}>
 {recipe.name} ({recipe.ingredient_count} ingredients)
 </SelectItem>
 ))
 )}
 </SelectContent>
 </Select>
 <p className="text-xs text-muted-foreground">
 💡 Select a recipe to auto-fill ingredient costs
 </p>
 </div>
 {recipes.length === 0 && (
 <div className="bg-slate-50 dark:bg-slate-800 p-3 rounded-lg">
 <p className="text-xs text-muted-foreground">
 No recipes yet? <button onClick={() => navigate('/recipes')} className="text-blue-600 hover:underline">Create your first recipe</button>
 </p>
 </div>
 )}
 </div>
 )}
 </CardContent>
 </Card>
 );
};

export default RecipeIntegration;
